import { Hero } from "../components/sections/Hero";
import { WeeklyPreview } from "../components/sections/WeeklyPreview";
import Section03 from "../components/sections/Section03";
import Section04 from "../components/sections/Section04";
import Section05 from "../components/sections/Section05";
import Section06 from "../components/sections/Section06";
import Section07 from "../components/sections/Section07";
import Section08FAQ from "../components/sections/Section08FAQ";
import Section09CTA from "../components/sections/Section09CTA";
import Section10Footer from "../components/sections/Section10Footer";

export default function Home() {
  return (
    <>
      <Hero />
      <WeeklyPreview />
      <Section03 />
      <Section04 />
      <Section05 />
      <Section06 />
      <Section07 />
      <Section08FAQ />
      <Section09CTA />
      <Section10Footer />
    </>
  );
}